import { render } from "./DetailInventairePage.vue?vue&type=template&id=20c3806b&ts=true"
import script from "./DetailInventairePage.vue?vue&type=script&lang=ts"
export * from "./DetailInventairePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__